import React from "react";
import CasesTable from "@/components/CasesTable";
import { useI18n } from "@/context/I18nContext";

export default function PortalDocuments() {
  const { lang } = useI18n();
  const L = (it, en, de) => (lang === "en" ? en : lang === "de" ? (de ?? it) : it);
  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-heading text-2xl font-medium text-white">{L("Documenti", "Documents", "Dokumente")}</h2>
        <p className="mt-1 text-slate-400">{L("Apri una pratica per caricare e gestire i documenti in modo sicuro.", "Open a case to securely upload and manage documents.", "Öffnen Sie einen Fall, um Dokumente sicher hochzuladen und zu verwalten.")}</p>
      </div>
      <CasesTable endpoint="/cases" basePath="/portal/cases" />
    </div>
  );
}
